// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"353":"contact","752":"project-detail"}[chunkId] || chunkId) + "." + {"353":"962a1710","730":"962a1710","752":"962a1710"}[chunkId] + ".chunk.css";
};